import React, { FC, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import MenuCard from './MenuCard';
import { Design, DesignConnection } from '../../../../shared/types/core/design';
import { useQueryParam } from '../../../../common/hooks/use-query-param';
import ActionModal, { ActionType } from '../modal/ActionModal';
import { MODAL } from '../../../../constants/core/menu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

interface SiteSlideProps {
    designs: DesignConnection;
    accountId: number;
}
const MenuSlide: FC<SiteSlideProps> = ({ designs, accountId }) => {
    const [modal, setModal] = useQueryParam<string | null>('modal');
    const [currentDesign, setCurrentDesign] = useState<Design | undefined>();

    const handleActionClick = (action: ActionType) => {
        const baseUrl = process.env.REACT_APP_CORE_APP_URL;
        if (!currentDesign) return;
        switch (action) {
            case ActionType.EDIT:
                window.location.href = `${baseUrl}/account/${accountId}/menus/${currentDesign.id}`;
                break;
            case ActionType.DELETE:
                window.location.href = `${baseUrl}/account/${accountId}/menus?modal=MENU_DELETE&designId=${currentDesign.id}`;
                break;
            case ActionType.SETTING:
                window.location.href = `${baseUrl}/account/${accountId}/menus?modal=MENU_SETTING&designId=${currentDesign.id}`;
                break;
            case ActionType.SHARE:
                window.location.href = `${baseUrl}/account/${accountId}/menus?modal=MENU_SHARE&designId=${currentDesign.id}`;
                break;
            case ActionType.PREVIEW:
                window.location.href = `${baseUrl}/account/${accountId}/menus/${currentDesign.id}?screen=preview`;
                break;
        }
    };

    const handleClickAddNew = () => {
        const baseUrl = process.env.REACT_APP_CORE_APP_URL;
        window.location.href = `${baseUrl}/account/${accountId}/menus/?modal=MENU_CREATE`;
    };

    return (
        <div className={`mb-20 swipe-h-auto`}>
            <Swiper
                observer={true}
                initialSlide={0}
                spaceBetween={14}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 2.5,
                    },
                    '@0.3': {
                        slidesPerView: 2.5,
                    },
                    '@0.5': {
                        slidesPerView: 2.5,
                    },
                    '@0.8': {
                        slidesPerView: 3,
                    },
                    '@1.10': {
                        slidesPerView: 4,
                    },
                    '@1.3': {
                        slidesPerView: 5,
                    },
                    '@1.50': {
                        slidesPerView: 6,
                    },
                    '@1.75': {
                        slidesPerView: 7,
                    },
                    '@2': {
                        slidesPerView: 8,
                    },
                }}
            >
                {designs?.edges &&
                    designs?.edges.map((menu, idx) => (
                        <SwiperSlide key={idx} className={'h-150'}>
                            {menu.node && (
                                <MenuCard
                                    menu={{
                                        ...menu.node,
                                        accountId,
                                    }}
                                    onClickMoreAction={() => {
                                        setCurrentDesign(menu.node);
                                        setModal(MODAL.ACTION);
                                    }}
                                    onClickThumbnail={() => {
                                        setCurrentDesign(menu.node);
                                        handleActionClick(ActionType.EDIT);
                                    }}
                                />
                            )}
                        </SwiperSlide>
                    ))}
                {designs.edges && (
                    <SwiperSlide key={'new-menu'}>
                        <div
                            onClick={handleClickAddNew}
                            className={
                                'cursor-pointer h-full rounded-8 border-teal text-teal border border-dashed flex flex-col items-center justify-center'
                            }
                        >
                            <FontAwesomeIcon size={'lg'} icon={faPlus} />
                            <span className={`px-10 text-16 font-semibold leading-20`}>New Menu</span>
                        </div>
                    </SwiperSlide>
                )}
            </Swiper>
            <ActionModal
                open={modal === MODAL.ACTION}
                onClose={() => {
                    setModal('');
                }}
                onActionClick={handleActionClick}
            />
        </div>
    );
};
export default MenuSlide;
